import * as RadixTooltip from '@radix-ui/react-tooltip';
import { ReactNode } from 'react';

export const Tooltip = ({
  children,
  content,
  isDisabled,
  triggerClassNames,
}: {
  isDisabled?: boolean;
  children: ReactNode;
  content: ReactNode;
  triggerClassNames?: string;
}) => {
  return (
    <RadixTooltip.Root>
      <RadixTooltip.Trigger
        {...(isDisabled && {
          onPointerMove: (event: any) => event && event.preventDefault(),
          onFocus: (event: any) => event.preventDefault(),
        })}
        className={triggerClassNames}
      >
        {children}
      </RadixTooltip.Trigger>
      <RadixTooltip.Portal>
        <RadixTooltip.Content
          className="z-20 px-3 pt-1 pb-1.5 font-sans text-xs leading-tight text-left text-white bg-black rounded-full bg-opacity-90"
          style={{ maxWidth: 240 }}
        >
          {content}
        </RadixTooltip.Content>
      </RadixTooltip.Portal>
    </RadixTooltip.Root>
  );
};
